"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.find = exports.stat = void 0;
const fs = require("fs");
const path_1 = require("path");
const util_1 = require("util");
const common_1 = require("./common");
const debug_1 = require("./debug");
const readdir = util_1.promisify(fs.readdir);
exports.stat = util_1.promisify(fs.stat);
async function find(src) {
    const result = [];
    await traverse(src, (filePath, stats) => {
        if (!stats.isFile() || stats.size > common_1.MAX_SUPPORTED_FILE_SIZE) {
            return;
        }
        result.push(filePath);
    });
    return result;
}
exports.find = find;
async function traverse(src, handle) {
    try {
        const stats = await exports.stat(src);
        if (!stats.isDirectory()) {
            handle(src, stats);
            return;
        }
        const entries = await readdir(src);
        for (const entry of entries) {
            const absolute = path_1.join(src, entry);
            await traverse(absolute, handle);
        }
    }
    catch (error) {
        debug_1.debug(error.message || `Error reading file ${src}. ${error}`);
    }
}
//# sourceMappingURL=find.js.map